let carts = document.querySelectorAll("#benefits .benefits-list__item");
carts.forEach((cart) => {
  cart.addEventListener("mouseover", function () {
    cart.classList.remove("overlay--fadeOut");
  });
  cart.addEventListener("mouseout", function () {
    cart.classList.add("overlay--fadeOut");
  });
});
